<script setup>
import { computed } from 'vue';
import Tag from 'primevue/tag';
import ArgonButton from "@/components/Argon/ArgonButton.vue";

const props = defineProps({
  subscription: {
    type: Object,
    default: null
  }
});

const getStatusSeverity = (status) => {
  if (status === 'active') return 'success';
  if (status === 'past_due' || status === 'unpaid') return 'danger';
  if (status === 'canceled') return 'warning';
  return 'info';
};

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric'
  });
};

const formattedAmount = computed(() => {
  if (!props.subscription) return '';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: props.subscription.currency || 'GBP'
  }).format(props.subscription.amount);
});
</script>

<template>
  <div class="card h-100">
    <div class="card-header pb-0 p-3">
      <div class="row">
        <div class="col-6 d-flex align-items-center">
          <h6 class="mb-0">Current Plan</h6>
        </div>
        <div class="col-6 text-end" v-if="subscription">
          <Tag :severity="getStatusSeverity(subscription.status)" class="text-capitalize">
            {{ subscription.status.replace('_', ' ') }}
          </Tag>
        </div>
      </div>
    </div>
    <div class="card-body p-3 pb-0">
      <ul class="list-group" v-if="subscription">
        <li class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
          <div class="d-flex flex-column">
            <h6 class="mb-1 text-dark font-weight-bold text-sm">Plan</h6>
            <span class="text-xs text-capitalize">{{ subscription.tier }}</span>
          </div>
          <div class="d-flex align-items-center text-dark text-sm font-weight-bold">
            {{ formattedAmount }} / month
          </div>
        </li>
        <li class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
          <div class="d-flex flex-column">
            <h6 class="text-dark mb-1 font-weight-bold text-sm">Next Payment</h6>
            <span class="text-xs">Subscription renewal date</span>
          </div>
          <div class="d-flex align-items-center text-dark text-sm font-weight-bold">
            {{ formatDate(subscription.nextBilledAt) }}
          </div>
        </li>
      </ul>
      <div v-else class="text-center p-3">
        <i class="fas fa-file-invoice-dollar fa-2x text-muted mb-3"></i>
        <h6 class="text-muted">No Active Subscription</h6>
        <p class="text-sm">Please choose a plan to get started.</p>
        <ArgonButton color="primary" variant="gradient" class="mt-2">View Plans</ArgonButton>
      </div>
    </div>
    <div class="card-footer text-end pt-0 px-3" v-if="subscription">
      <ArgonButton color="secondary" variant="outline">Manage Subscription</ArgonButton>
    </div>
  </div>
</template>
